import React from 'react';

import { Card, CardContent, CardHeader, CardTitle, DonutChart } from '@mesh.ai/rabbit';

interface ChartDataItem {
  label: string;
  labelColor: string;
  value: number;
  color: string;
}

interface Props {
  chartData?: ChartDataItem[];
}

export const GoalsDonutChart = ({ chartData }: Props) => (
  <Card style={{ height: '100%' }}>
    <CardHeader>
      <CardTitle>Distribution</CardTitle>
    </CardHeader>
    <CardContent>
      <div
        className="rabbit-ds"
        style={{
          height: '180px',
          width: '100%',
        }}
      >
        <DonutChart tooltipTitle="Goal Distribution" legendTitle="Distribution" data={chartData} />
      </div>
    </CardContent>
  </Card>
);
